import {Component} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import 'rxjs/add/operator/filter';

@Component({
  selector: 'app-breadcrumbs',
  template: `
  <ng-template ngFor let-breadcrumb [ngForOf]="breadcrumbs" let-last = last>
    <li class="breadcrumb-item"
        *ngIf="breadcrumb.label&&breadcrumb.url.substring(breadcrumb.url.length-1) == '/'||breadcrumb.label&&last"
        [ngClass]="{active: last}">
      <a *ngIf="!last" [routerLink]="breadcrumb.url">{{breadcrumb.label.title}}</a>
      <span *ngIf="last" [routerLink]="breadcrumb.url">{{breadcrumb.label.title}}</span>
    </li>
  </ng-template>`
})
export class AppBreadcrumbsComponent {
  breadcrumbs: Array<Object>;

  constructor(
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.router.events.filter(event => event instanceof NavigationEnd).subscribe((event) => {
      this.breadcrumbs = [];

      let currentRoute = this.route.root,
        url = '';
      // console.log("currentRoute: ",currentRoute);
      do {
        const childrenRoutes = currentRoute.children;
        currentRoute = null;
        childrenRoutes.forEach(route => {
          if (route.outlet === 'primary') {
            const routeSnapshot = route.snapshot;
            let tmp = routeSnapshot.url.map(segment => segment.path);
            if (tmp.length > 0) {
              url += '/' + tmp.join('/');
              this.breadcrumbs.push({
                label: route.snapshot.data,
                url: url
              });
            }
            // console.log("tmp: ",this.breadcrumbs);
            // console.log({
            //   label: route.snapshot.data,
            //   url:   url
            // });
            currentRoute = route;
          }
        });
      } while (currentRoute);
    });
  }
}
